jQuery(document).ready(function($) {
    if (!is_dev) return;

    // add_evaluation().then((elm, popup) => {
    //     setTimeout(ajax_popup_scroll_to_next_screen, 2000);
    // });
});


(function ($) {
    $.fn.customSortable = function (params) {

        if (params && params.onChange) {
            params.onChange();
        }

        $(this).each(function () {
            const elm = $(this);

            elm.children('.sortable-item').each(function(index) {
                addDefaultUi($(this), index, params);
                initInputEvents($(this));
            });


            toggleTrashButtons(elm);
            elm.sortable({
                handle: '.drag-handle-wrapper button',
                cancel: '',
                update: function() {
                    updateInputNames(elm);
                    resetRichTextAreas(elm);
                    if (params && params.onChange) {
                        params.onChange();
                    }
                }
            });
        });
        return this;
    };

    /**
     * Inputs fill the view-wrapper, so when you collapse your scroll-item, you see the accurate data
     *
     * @param sortableItem
     */
    function initInputEvents(sortableItem) {
        sortableItem.find(':input[id]').unbind('keyup.customSortable change.customSortable').bind('keyup.customSortable change.customSortable', function() {
            const id = $(this).attr('id');
            $(this).parents('.sortable-item:first').find('.view-wrapper').find('span.' + id + '-container').html($(this).val());
        }).trigger('change.customSortable');
    }

    /**
     * Add all necessary buttons and other ui-elements to this Si
     *
     * @param sortableItem
     * @param index
     */
    function addDefaultUi(sortableItem, index, params) {
        /*
        Si gets a buttonWrapper
         */
        const uiWrapper = $('<div></div>');
        uiWrapper.addClass('buttons-wrapper');
        sortableItem.append(uiWrapper);


        /*
        Expand button gets added to the Si
         */
        const expandButtonWrapper = $('<div />');
        const expandButton = $('<button />');
        expandButtonWrapper.addClass('expand-button-wrapper');
        expandButton.addClass('button primary');
        expandButton.click(function() {
            expandButtonHandle($(this));
            return false;
        });
        expandButtonWrapper.html(expandButton);
        uiWrapper.append(expandButtonWrapper);
        expandButton.toggleClass('open', index > 0).click();


        /*
        TrashButton gets added to the Si
         */
        const trashButtonWrapper = $('<div></div>');
        trashButtonWrapper.addClass('trash-button-wrapper');
        uiWrapper.append(trashButtonWrapper);
        const trashButton = $('<button><span class="visual-icon-trash icon-white" /></button>');
        trashButton.addClass('button primary');
        trashButton.click(function() {
            removeItem($(this).parents('.sortable-item:first'));
            return false;
        });
        trashButtonWrapper.append(trashButton);


        /*
        DragHandle gets added to the Si
         */
        const dragHandleWrapper = $('<div></div>');
        dragHandleWrapper.addClass('drag-handle-wrapper');
        uiWrapper.append(dragHandleWrapper);
        const dragHandle = $('<button><span class="visual-icon-move icon-white" /></button>');
        dragHandle.addClass('button primary');
        dragHandle.click(() => false);
        dragHandle.mousedown(function() {
            const expandButton = $(this).parents('.buttons-wrapper:first').find('.expand-button-wrapper').find('button');
            if (expandButton.hasClass('open')) {
                expandButtonHandle(expandButton);
            }
        });
        dragHandleWrapper.append(dragHandle);

        /*
        Plus buttons on top and below the Si
         */
        const plusButtonWrapper = $('<div></div>');
        plusButtonWrapper.addClass('plus-button-wrapper');
        const plusButton = $('<div></div>');
        plusButton.click(function() {
            addItem('before', $(this).parents('.sortable-item:first'));
            if (params && params.onChange) {
                params.onChange();
            }
        });
        plusButton.addClass('plus-button');
        if (sortableItem.is('[data-new-item-string]')) {
            plusButton.html(sortableItem.attr('data-new-item-string'));
            plusButton.addClass('button primary');
            plusButtonWrapper.addClass('has-text-button');
        }
        plusButtonWrapper.html(plusButton);

        const bottomPlusButtonWrapper = plusButtonWrapper.clone();
        bottomPlusButtonWrapper.find('.plus-button').click(function() {
            addItem('after', $(this).parents('.sortable-item:first'));
            if (params && params.onChange) {
                params.onChange();
            }
        });
        sortableItem.prepend(plusButtonWrapper).append(bottomPlusButtonWrapper);
    }

    function addItem(where, sortableItem) {
        // Close the current Si when adding one below
        if (where === 'after') {
            sortableItem.find('.expand-button-wrapper button').toggleClass('open', true).click();
        }

        const newSortableItem = sortableItem.clone(true, true);
        newSortableItem.find('.sortable-item:not(:first)').remove();
        if (where === 'before') {
            sortableItem.before(newSortableItem);
        } else {
            sortableItem.after(newSortableItem);
        }
        newSortableItem.find(':input:not(.special-selector-search-bar):not(select)').each(function() {
            const input = $(this);
            input.val('').trigger('change').trigger('keyup');
        });
        newSortableItem.find('.expand-button-wrapper button').toggleClass('open', false).click();

        newSortableItem.find('textarea[data-tinymce-id]').each(function() {
            const textarea = $(this);
            textarea.removeAttr('data-tinymce-id').removeAttr('aria-hidden').removeAttr('style');
            textarea.prev().remove();
        });

        newSortableItem.find('.mce-container').remove();

        newSortableItem.find(':input:not(.special-selector-search-bar):first').focus();

        resetRichTextAreas(sortableItem);

        toggleTrashButtons(newSortableItem.parent());

        updateInputNames(newSortableItem.parent());

        newSortableItem.trigger('afterClone', newSortableItem);
        // newSortableItem.css({border: 'solid 1px red'});
    }

    function removeItem(sortableItem) {
        const wrapper = sortableItem.parent();
        sortableItem.trigger('willRemove');
        sortableItem.remove();
        toggleTrashButtons(wrapper);
        updateInputNames(wrapper);
    }

    /**
     * Make sure that the input names match the order of sort items
     *
     * @param wrapper
     */
    function updateInputNames(wrapper) {
        wrapper.find('.sortable-item').each(function() {
            const index = $(this).index();
            const sortableItem = $(this);
            const depth = sortableItem.parents('.sortable-wrapper').length;

            sortableItem.find('[name]').each(function() {
                let name = $(this).attr('name');
                const p = name.split('[');

                const splitIndex = (() => {
                    return depth + (depth - 1);
                })();

                p[splitIndex] = index + ']';
                name = p.join('[');
                $(this).attr('name', name);

                if ($(this).is('[id]')) {
                    const currentId = $(this).attr('id');
                    const label = sortableItem.find('label[for="' + currentId + '"]');
                    if (label.length > 0) {
                        const newId = name.split('[').join('-').split(']').join('-');
                        $(this).attr('id', newId);
                        label.attr('for', newId);

                        sortableItem.find('.view-wrapper').find('.' + currentId + '-container').removeClass(currentId + '-container').addClass(newId + '-container');
                    }
                }
            });
        });
    }

    /**
     * Make sure text areas keep working
     *
     * @param wrapper
     */
    function resetRichTextAreas(wrapper) {
        wrapper.find('textarea[data-tinymce-id]').each(function(index) {
            const textarea = $(this);
            textarea.removeAttr('data-tinymce-id').removeAttr('aria-hidden').removeAttr('style');
            textarea.prev().remove();
        });

        wrapper.find('textarea').customTextarea();
    }

    /**
     * Disable or enable the trash buttons.
     * It should be disabled, when you only have one question left on the screen.
     *
     * @param wrapper
     */
    function toggleTrashButtons(wrapper) {
        wrapper.children('.sortable-item').children('.buttons-wrapper').find('.trash-button-wrapper button').attr('disabled', wrapper.children('.sortable-item').length < 2);
    }

    /**
     * Code that runs when you click the expand button within a Si
     *
     * @param button
     */
    function expandButtonHandle(button) {
        button.toggleClass('open');
        const sortableItem = button.parents('.sortable-item:first');
        sortableItem.children('.view-wrapper').toggle(!button.hasClass('open'));
        sortableItem.children('.edit-wrapper').toggle(button.hasClass('open'));
    }

}(jQuery));
